import Vue from 'vue';
import Component from 'vue-class-component';
import {RouterMenu} from './components/router-menu';

@Component({
  template: require('./app.html'),
  components: {
    RouterMenu
  }
})
export class App extends Vue {
}





// WEBPACK FOOTER //
// src/app.ts